import React, { useState } from "react";
import { Reserva, ReservaUpdatePayload } from "../../types/reserva.types";
import { Button, Dialog, Field, Input } from "../ui";
import { t } from "../../i18n";

interface ReservaEditModalProps {
  reserva: Reserva;
  saving: boolean;
  onConfirm: (payload: ReservaUpdatePayload) => void;
  onClose: () => void;
}

// Edita a reserva em si (não o vínculo com este médico) — como a mesma
// reserva pode ser compartilhada por mais de um médico (dedup por nome no
// cadastro), a alteração aqui reflete para todos que a têm vinculada.
const ReservaEditModal: React.FC<ReservaEditModalProps> = ({ reserva, saving, onConfirm, onClose }) => {
  const [name, setName] = useState(reserva.name);

  const trimmedName = name.trim();
  const hasChanges = !!trimmedName && trimmedName !== reserva.name;
  const canSubmit = !saving && hasChanges;

  const handleSave = () => {
    if (!canSubmit) return;
    onConfirm({ name: trimmedName });
  };

  return (
    <Dialog
      open
      size="sm"
      onClose={onClose}
      closeDisabled={saving}
      title={t("links.reserva.editTitle")}
      description={t("links.reserva.editText")}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            {t("common.cancel")}
          </Button>
          <Button variant="primary" onClick={handleSave} disabled={!canSubmit}>
            {saving ? t("links.saving") : t("links.save")}
          </Button>
        </>
      }
    >
      <Field label={t("links.name")}>
        <Input
          type="text"
          value={name}
          disabled={saving}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key !== "Enter") return;
            e.preventDefault();
            handleSave();
          }}
          placeholder={t("links.reserva.nameField")}
        />
      </Field>
    </Dialog>
  );
};

export default ReservaEditModal;
